/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { Timestamp } from "../../google/protobuf/timestamp";

export const protobufPackage = "Reality.Reality.Api";

export interface HistoryAlbumBroadcastRecord {
  liveName: string;
  liveDate: Date | undefined;
  maxViewingCount: number;
}

function createBaseHistoryAlbumBroadcastRecord(): HistoryAlbumBroadcastRecord {
  return { liveName: "", liveDate: undefined, maxViewingCount: 0 };
}

export const HistoryAlbumBroadcastRecord = {
  encode(message: HistoryAlbumBroadcastRecord, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.liveName !== "") {
      writer.uint32(10).string(message.liveName);
    }
    if (message.liveDate !== undefined) {
      Timestamp.encode(toTimestamp(message.liveDate), writer.uint32(18).fork()).ldelim();
    }
    if (message.maxViewingCount !== 0) {
      writer.uint32(24).int64(message.maxViewingCount);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): HistoryAlbumBroadcastRecord {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHistoryAlbumBroadcastRecord();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.liveName = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.liveDate = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.maxViewingCount = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HistoryAlbumBroadcastRecord {
    return {
      liveName: isSet(object.liveName) ? globalThis.String(object.liveName) : "",
      liveDate: isSet(object.liveDate) ? fromJsonTimestamp(object.liveDate) : undefined,
      maxViewingCount: isSet(object.maxViewingCount) ? globalThis.Number(object.maxViewingCount) : 0,
    };
  },

  toJSON(message: HistoryAlbumBroadcastRecord): unknown {
    const obj: any = {};
    if (message.liveName !== "") {
      obj.liveName = message.liveName;
    }
    if (message.liveDate !== undefined) {
      obj.liveDate = message.liveDate.toISOString();
    }
    if (message.maxViewingCount !== 0) {
      obj.maxViewingCount = Math.round(message.maxViewingCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HistoryAlbumBroadcastRecord>, I>>(base?: I): HistoryAlbumBroadcastRecord {
    return HistoryAlbumBroadcastRecord.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HistoryAlbumBroadcastRecord>, I>>(object: I): HistoryAlbumBroadcastRecord {
    const message = createBaseHistoryAlbumBroadcastRecord();
    message.liveName = object.liveName ?? "";
    message.liveDate = object.liveDate ?? undefined;
    message.maxViewingCount = object.maxViewingCount ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
